import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "auth-wrapper d-flex h-100 w-100 align-items-center flex-column" }
const _hoisted_2 = { class: "auth-form" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_9 = { class: "text-nowrap" }
const _hoisted_10 = { class: "flex-fill text-right" }
const _hoisted_11 = ["onClick", "title", "src"]
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "flex-fill" }

import {computed, onBeforeUnmount, onMounted, ref} from 'vue';
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {OperatorApplicationLanguagesList} from "~/operatorApplication/ts/data/OperatorApplicationLanguagesList";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import operatorLogin, {isAuthorizedOnce} from "~/operatorApplication/ts/service/status/OperatorLogin";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import {__} from "~/ts/library/Translate";

interface LastLoginInterface {
    login: string;
    password: string
}


const __default__ = {
    name: "OperatorApplicationAuth",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const LAST_LOGIN_KEY = "lastLogin";
const PREVIOUS_LOGINS = "previousLogins";

let login = ref<string>();
let password = ref<string>();
let remember = ref(true);
let error = ref<string>();

let logoSrc = computed(() => `${OperatorConfigStore.assetsPath.value}/images/brands/${OperatorConfigStore.brandId.value}/auth.png`);
let isReadyToSend = computed(() => typeof login.value == "string" && typeof password.value == "string" && login.value.length && password.value.length);

let lastLogin = computed<LastLoginInterface>(() => {
    let credentials = OperatorAccountStore.credentialsForAuthAfterLoad.value;
    if (credentials) {
        return credentials;
    } else {
        let lastLogin: LastLoginInterface = StorageInstance.get(LAST_LOGIN_KEY);
        if (!lastLogin) {
            try {
                if (!StorageInstance.get("loginOnce")) {
                    let login = window.localStorage.getItem("db::-1::login");
                    let password = window.localStorage.getItem("db::-1::password");
                    if (login && password) {
                        lastLogin = {
                            login: JSON.parse(login),
                            password: JSON.parse(password)
                        };
                    }
                }
            } catch (e) {

            }
        }
        return lastLogin;
    }
});

let previousLogins = computed(() => {
    let previousLogins: string[] = StorageInstance.get(PREVIOUS_LOGINS);
    if (!Array.isArray(previousLogins)) {
        previousLogins = [];
    }
    return previousLogins;
});

onMounted(() => {
    document.body.classList.add("auth");
    if (OperatorAccountStore.isCabinetIframe) {
        if (!OperatorAccountStore.login.value) {
            operatorLogin(OperatorAccountStore.cabinetReportsOperatorLogin.value ?? "cabinetReport", "cabinetReport", 0);
        }
    } else {
        if (OperatorAccountStore.logoutError.value) {
            error.value = OperatorAccountStore.logoutError.value;
            OperatorAccountStore.setLogoutError();
        }
        OperatorApplicationPlatform.window.resize(750, 600, true, false);
        if (lastLogin.value) {
            login.value = lastLogin.value.login;
            password.value = lastLogin.value.password;
            if (!isAuthorizedOnce() && OperatorApplicationPlatform.isNative) {
                auth();
            }
        }
    }
});

onBeforeUnmount(() => document.body.classList.remove("auth"));

function rememberCurrentLogin() {
    let loginValue = login.value.toLowerCase();
    toggleArrayElement(previousLogins.value, loginValue, false);
    previousLogins.value.splice(0, 0, loginValue);

    StorageInstance.set(PREVIOUS_LOGINS, previousLogins.value);

    if (remember.value) {
        StorageInstance.set(LAST_LOGIN_KEY, {
            login: loginValue,
            password: password.value
        } as LastLoginInterface);
    } else {
        StorageInstance.remove(LAST_LOGIN_KEY);
    }
}

async function auth() {
    if (isReadyToSend.value) {
        error.value = null;
        let currentVersion: string;
        if (OperatorApplicationPlatform.updater) {
            currentVersion = await OperatorApplicationPlatform.updater.getCurrentApplicationVersion();
        }

        let p: OperatorApplicationApi.OperatorMakeAuthOpenApiModel = {
            platformId: OperatorApplicationPlatform.platformId as any,
            os: OperatorApplicationPlatform.platformDescr,
            applicationVersion: currentVersion,
            applicationSupportSeparateFIO: true,
            applicationSupportMessageState: true,
            applicationSupportQuestionCategoryTree: true,
            applicationSupportSiteIdsInAutoTemplates: true
        };
        if (OperatorApplicationConfigInstance.rememberLastOperatorStatus) {
            let statusId = OperatorApplicationConfigInstance.lastOperatorStatus;
            if (typeof statusId == "number") {
                p.status = {
                    id: statusId,
                    customStatusId: OperatorApplicationConfigInstance.lastOperatorCustomStatus
                }
            }
        }

        let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorMakeAuthResultOpenApiModel>({
            url: "/auth/makeAuth",
            p
        })).setCredentials(
            login.value.toLowerCase(),
            password.value,
            OperatorAccountStore.tokenId.value
        ).send();

        if (result.isSuccess) {
            let data: OperatorApplicationApi.OperatorMakeAuthResultOpenApiModel = result.data;
            StorageInstance.set("loginOnce", true);
            rememberCurrentLogin();

            await operatorLogin(login.value, password.value, data.currentCometTime);

        } else {
            OperatorAccountStore.SET_MINIMIZE_AFTER_STARTUP(false);
            error.value = result.descr;
            OperatorApplicationConfigInstance.useInternationalHostIfNeed();
        }
    }
}


let languages = computed(() => {
    return OperatorApplicationLanguagesList;
});

let selectedLanguageId = computed(() => {
    return OperatorApplicationConfigInstance.languageId;
});

function selectLanguage(id: string) {
    OperatorApplicationConfigInstance.languageId = id;
    OperatorApplicationConfigInstance.init(OperatorApplicationPlatform.isNative);
}

function loginsSuggest(queryString: string, cb: ((logins: { value: string }[]) => void)) {
    cb(previousLogins.value.map(login => ({value: login})));
}


return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "auth-logo",
          src: _unref(logoSrc)
        }, null, 8, _hoisted_4)
      ]),
      (!_unref(OperatorAccountStore).isCabinetIframe)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_autocomplete, {
                modelValue: _unref(login),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(login) ? (login).value = $event : login = $event)),
                placeholder: _unref(__)('Логин оператора'),
                "fetch-suggestions": loginsSuggest,
                class: "w-100",
                onSelect: _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) //@ts-ignore
 ? password.value = null : password = null))
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_input, {
                modelValue: _unref(password),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
                type: "password",
                "show-password": "",
                placeholder: _unref(__)('Пароль')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_unref(error))
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 0,
                    title: _unref(error),
                    closable: true,
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (_isRef(error) //@ts-ignore
 ? error.value = null : error = null)),
                    type: "error",
                    effect: "dark"
                  }, null, 8, ["title"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _unref(remember),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(remember) ? (remember).value = $event : remember = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(__)("Запомнить")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: language.id,
                          onClick: ($event: any) => (selectLanguage(language.id)),
                          title: language.descr,
                          src: `assets/operatorApplication/images/languages/${language.id}.png`,
                          class: _normalizeClass({
                                flag: true,
                                selected: language.id === _unref(selectedLanguageId)
                            })
                        }, null, 10, _hoisted_11))
                      }), 128))
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  disabled: !_unref(isReadyToSend),
                  onClick: auth,
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(__)("Подключиться")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-fill" }, null, -1))
  ]))
}
}

})